import {gql} from 'apollo-boost';

export default gql `
mutation ($uploadId: Float!) {
  downloadJobUpload(uploadId: $uploadId)
}
`;
